import React from "react";
import "../css/service.css";

import interiror1 from "../assets/about1.jpeg";
import acRepairImage from "../assets/about2.jpeg";
import acInstallImage from "../assets/ac-home.webp";      // <-- replace path if needed
import acCleaningImage from "../assets/ac.webp";    // <-- replace path if needed
import acMaintenanceImage from "../assets/carousel-1.jpg"; // <-- replace path if needed
import Topbar from "../components/Topbar";
import Header from "../components/header";
import Footer from "../screen/Footer"; 
import Herolast  from "../screen/herolast";

export default function Service() {
  const services = [
    {
      id: "01",
      title: "AC Repair",
      desc:
        "Our experienced technicians are ready to diagnose and fix any AC issues, ensuring your comfort is restored in no time.",
      img: acRepairImage,
    },
    {
      id: "02",
      title: "AC Installation",
      desc:
        "We provide expert installation of various air conditioning units, ensuring optimal performance and efficiency tailored to your specific needs.",
      img: acInstallImage,
    },
    {
      id: "03",
      title: "AC Cleaning",
      desc:
        "Regular cleaning of your AC unit enhances its performance and prolongs its lifespan, ensuring a healthier indoor environment.",
      img: acCleaningImage,
    },
    {
      id: "04",
      title: "Annual Maintenance",
      desc:
        "Our annual maintenance service includes comprehensive checks and servicing to prevent unexpected breakdowns, ensuring your AC operates smoothly year-round.",
      img: acMaintenanceImage,
    },
  ];

  return (
    <>
    <Topbar/>
          <Header />
      {/* Hero Section */}
      <div className="hero-container">
        {/* Background Image Container */}
        <div className="background-image">
          <div className="background-overlay"></div>
        </div>

        {/* Content Overlay */}
        <div className="content-overlay">
          <div className="content-card">
            <div className="welcome-section">
              <p className="welcome-text">RELIABLE SERVICES</p>
            </div>

            <h1 className="main-heading">Expert AC Solutions for Every Need</h1>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          {services.map((service, index) => {
            const isReverse = index % 2 === 1; // alternate layout
            return (
              <div
                key={service.id}
                className={`service-card ${isReverse ? "reverse" : ""}`}
              >
                <div className="service-image">
                  <img src={service.img} alt={service.title} />
                </div>

                <div className="service-content">
                  <div className="service-number">{service.id}</div>
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <Herolast  />
      <Footer  />
    </>
  );
}
